import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {Pagination} from "@/models/sit-pedido/pagination";
import {Lote} from "@/models/sie-pedidos/lote";
import {DadosFilterSolicitacao, PaginationTableSiePedidos} from "@/store/modules/sie-pedidos/states/table";
import {PaginationTableLotes} from "@/store/modules/sie-pedidos/states/tableLotes";
import {Solicitacao} from "@/models/sie-pedidos/solicitacao";
import {EntidadeApi} from "@/api/sie-pedidos/entidade.api";

const api = new EntidadeApi();

const getLista = (input: PaginationTableSiePedidos): AxiosObservable<Pagination<Solicitacao>> => {
  return api.getLista(input);
};
const getDadosFilterSolicitacao = (): AxiosObservable<DadosFilterSolicitacao> =>{
  return api.getDadosFilterSolicitacao()
};

const getDetalhamentoSolicitacao = (id: any): AxiosObservable<any> =>{
  return api.getDetalhamentoSolicitacao(id)
}

const getListHistoricoSolicitacao = (idSolicitacao: number): AxiosObservable<any>=>{
  return api.getListHistoricoSolicitacao(idSolicitacao)
}

const receberSolicitacaoSindionibus = (ids: number): AxiosObservable<any>=>{
  return api.receberSolicitacaoSindionibus(ids)
}

const enviarCarteiraAluno = (ids: number[]): AxiosObservable<any>=>{
  return api.enviarCarteiraAluno(ids)
}

const getListaLotesPorEntidade = (filter: PaginationTableLotes): AxiosObservable<Pagination<Lote>> => {
  return api.getListaLotesPorEntidade(filter);
};

const getListaStatusLotes = (): AxiosObservable<[]> =>{
  return api.getListaStatusLotes();
}

const getListHistoricoLote = (idLote: any): AxiosObservable<any> =>{
  return api.getListHistoricoLote(idLote);
}

export default {
  getLista,
  getDadosFilterSolicitacao, getDetalhamentoSolicitacao,
  getListHistoricoSolicitacao,
  receberSolicitacaoSindionibus, enviarCarteiraAluno,
  getListaLotesPorEntidade, getListaStatusLotes,
  getListHistoricoLote
}
